/*(c) Copyright 2015 Pivotal Software, Inc. All Rights Reserved.*/
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbList = exports.StepList = exports.GroupListInverse = exports.GroupList = exports.InlineList = exports.OrderedList = exports.UnorderedList = exports.ListItem = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('pui-css-lists');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = _react2.default.PropTypes;

var ListItem = exports.ListItem = function (_React$Component) {
  (0, _inherits3.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('li', this.props);
    }
  }]);
  return ListItem;
}(_react2.default.Component);

var defList = function defList(tagName, spacingType, classNames, childClassNames) {
  var _class, _temp;

  return _temp = _class = function (_React$Component2) {
    (0, _inherits3.default)(_class, _React$Component2);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);
      return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
    }

    (0, _createClass3.default)(_class, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            spacing = _props.spacing,
            children = _props.children,
            unstyled = _props.unstyled,
            divider = _props.divider,
            others = (0, _objectWithoutProperties3.default)(_props, ['className', 'spacing', 'children', 'unstyled', 'divider']);

        var classes = (0, _classnames2.default)(classNames(this.props), className, spacing && '' + spacingType + spacing);
        if (childClassNames) {
          children = _react2.default.Children.map(children, function (child) {
            return _react2.default.cloneElement(child, { className: childClassNames });
          });
        }

        return tagName === 'ul' ? _react2.default.createElement(
          'ul',
          (0, _extends3.default)({ className: classes }, others),
          children
        ) : tagName === 'ol' ? _react2.default.createElement(
          'ol',
          (0, _extends3.default)({ className: classes }, others),
          children
        ) : null;
      }
    }]);
    return _class;
  }(_react2.default.Component), _class.propTypes = {
    spacing: types.oneOf(['n', 's', 'm', 'l', 'xl']),
    className: types.string,
    unstyled: types.bool,
    divider: types.bool
  }, _temp;
};

var UnorderedList = exports.UnorderedList = defList('ul', 'lv', function (_ref) {
  var unstyled = _ref.unstyled;
  return (0, _classnames2.default)({
    'list-unordered': !unstyled,
    'list-unstyled': unstyled
  });
});

var OrderedList = exports.OrderedList = defList('ol', 'lv', function (_ref2) {
  var unstyled = _ref2.unstyled;
  return (0, _classnames2.default)({ 'list-unstyled': unstyled });
});
var InlineList = exports.InlineList = defList('ul', 'lh', function (_ref3) {
  var divider = _ref3.divider;
  return (0, _classnames2.default)('list-inline', { 'list-inline-divider': divider });
});
var GroupList = exports.GroupList = defList('ul', 'lv', function () {
  return (0, _classnames2.default)('list-group');
}, 'list-group-item');
var GroupListInverse = exports.GroupListInverse = defList('ul', 'lv', function () {
  return (0, _classnames2.default)('list-group-inverse');
}, 'list-group-item');
var StepList = exports.StepList = defList('ol', 'lh', function () {
  return (0, _classnames2.default)('list-steps');
});
var BreadcrumbList = exports.BreadcrumbList = defList('ul', 'lh', function () {
  return (0, _classnames2.default)('list-breadcrumb');
});


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/lists.js
// module id = 900
// module chunks = 0